var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17.97 13.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    className: "cls-1",
    width: 17.96,
    height: 13.16
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.26,6.47A3.23,3.23,0,1,0,2,3.24,3.23,3.23,0,0,0,5.26,6.47Zm0-5A1.78,1.78,0,1,1,3.49,3.24,1.78,1.78,0,0,1,5.26,1.46Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.71,6.47A3.23,3.23,0,1,0,9.48,3.24a3.23,3.23,0,0,0,3.23,3.23Zm0-5a1.78,1.78,0,1,1-1.78,1.78,1.78,1.78,0,0,1,1.78-1.78Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.71,7.12A5.28,5.28,0,0,0,9,8.67a5.25,5.25,0,0,0-9,3.72v.72H18v-.72a5.27,5.27,0,0,0-5.26-5.27ZM1.52,11.66a3.81,3.81,0,0,1,7.49,0Zm9,0a5.15,5.15,0,0,0-.61-1.82,3.81,3.81,0,0,1,6.58,1.82Z",
    transform: "translate(0 -0.01)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.c6043fb0ae3f3dca419a0f1344b92cd5.svg";
export { ForwardRef as ReactComponent };